import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import "./OfferSection.css";
import Loader from "./Loader";
import { offerSectionsAPI } from "../../utils/api";

export default function OfferSection() {
  const [offerSections, setOfferSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadOfferSections = async () => {
      try {
        setLoading(true);
        setError("");
        const data = await offerSectionsAPI.getActiveOfferSections();
        
        if (data.success && data.data) {
          setOfferSections(Array.isArray(data.data) ? data.data : []);
        } else {
          setOfferSections([]);
        }
      } catch (e) {
        console.warn("Failed to load offer sections:", e);
        setError(e.message || "Failed to load offers");
        setOfferSections([]);
      } finally {
        setLoading(false);
      }
    };

    loadOfferSections();
  }, []);

  // Use API data directly
  const displayOffers = offerSections;

  if (loading) {
    return (
      <section className="offer-section">
        <div className="offer-content">
          <div className="offer-loading">
            <Loader />
            <p>Loading offers...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      {displayOffers.map((offer, index) => (
        <section key={offer.id || index} className="offer-section">
          <div className="offer-content">
            {/* Left side - Image */}
            <div className="offer-image">
              <img
                src={offer.image_url}
                alt={offer.alt_text}
              />
            </div>

            {/* Right side - Text */}
            <div className="offer-text">
              <div className="offer-quote">"</div>
              <h2>{offer.discount_percentage}</h2>
              <p className="offer-title">
                {offer.title}
              </p>
              <p className="offer-desc">
                {offer.description}
              </p>

              {/* Button */}
              <Link to={offer.button_link} className="offer-btn">
                {offer.button_text}
              </Link>
            </div>
          </div>
        </section>
      ))}
      
    </>
  );
}
